import styled from 'styled-components';

export const Title = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  margin-bottom: 24px;
`;
export const LeftSide = styled.div`
  display: inline-block;
  width: 50%;
`;
export const RightSide = styled.div`
  display: inline-block;
  width: 50%;

  text-align: right;
  vertical-align: bottom;
`;
export const Text = styled.div`
  color: rgba(9, 21, 38, 0.6);

  font-size: 16px;
  line-height: 22px;
`;

export const Button = styled.a`
  display: inline-block;
  text-align: center;
  width: 240px;
  padding: 10px 16px;
  background-color: #7d52df;
  color: #ffffff;
  border-radius: 46px;
  cursor: pointer;
  outline: none;

  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.04em;
  text-transform: uppercase;

  &:hover,
  &:active,
  &:visited {
    color: #ffffff;
  }
`;
